import type { ProviderInfo } from '../types/foundObject';

export type ProviderDashboardMenuSettings = {
  matchings_enabled: boolean;
  linked_announcements_enabled: boolean;
};

const DEFAULT_DASHBOARD_MENU: ProviderDashboardMenuSettings = {
  matchings_enabled: true,
  linked_announcements_enabled: true,
};

function readBoolSetting(settings: Record<string, unknown> | null | undefined, key: string): boolean | undefined {
  if (!settings || !Object.prototype.hasOwnProperty.call(settings, key)) {
    return undefined;
  }
  return settings[key] !== false;
}

/** Lit les options de menu dashboard depuis provider-info (API ou settings JSON). */
export function getProviderDashboardMenuSettings(
  providerInfo?: ProviderInfo | null
): ProviderDashboardMenuSettings {
  if (providerInfo?.dashboard_menu) {
    return {
      matchings_enabled: providerInfo.dashboard_menu.matchings_enabled !== false,
      linked_announcements_enabled: providerInfo.dashboard_menu.linked_announcements_enabled !== false,
    };
  }

  const settings = providerInfo?.settings as Record<string, unknown> | null | undefined;
  const matchings = readBoolSetting(settings, 'dashboard_menu_matchings_enabled');
  const linked = readBoolSetting(settings, 'dashboard_menu_linked_announcements_enabled');

  return {
    matchings_enabled: matchings ?? DEFAULT_DASHBOARD_MENU.matchings_enabled,
    linked_announcements_enabled: linked ?? DEFAULT_DASHBOARD_MENU.linked_announcements_enabled,
  };
}

export function isProviderMatchingsMenuEnabled(providerInfo?: ProviderInfo | null): boolean {
  return getProviderDashboardMenuSettings(providerInfo).matchings_enabled;
}

export function isProviderLinkedAnnouncementsMenuEnabled(providerInfo?: ProviderInfo | null): boolean {
  return getProviderDashboardMenuSettings(providerInfo).linked_announcements_enabled;
}
